import { gql } from '@apollo/client';

export const GET_VIDEOS_WATCHED_BY_CATEGORY = gql`
  query GetVideosWatchedByCathegoryStat($statisticFilter: statisticFilter) {
    VideosWatchedByCathegoryStat(filter: $statisticFilter) {
      count
      users {
        user_id
        count
      }
      category {
        id
        parent_id
      }
    }
  }
`;

export const GET_VIEWED_HOUR_STAT = gql`
  query GetViewedHoursStat($viewedHoursFilter: ViewedHoursFilter) {
    ViewedHoursStat(filter: $viewedHoursFilter) {
      grouped_by_dates {
        date
        duration
        users {
          user_id
          duration
        }
      }
      total_view_duration
    }
  }
`;

export const GET_VIDEOS_WATCHED_COUNT_STAT = gql`
  query GetVideosWatchedCountStat($viewedVideosFilter: ViewedVideosFilter) {
    VideosWatchedCountStat(filter: $viewedVideosFilter) {
      grouped_by_dates {
        date
        count
        users {
          user_id
          count
        }
      }
      total_count_viewed_videos
    }
  }
`;

export const GET_PATHWAYS_PROGRESS_STAT = gql`
  query GetPathwaysProgressStat($pathwaysFilter: PathwayProgressFilter) {
    PathwaysProgressStat(filter: $pathwaysFilter) {
      count
      total_count_pathways
      users {
        current
        user_id
      }
    }
  }
`;

export const GET_CPD_CREDITS_STAT = gql`
  query GetCpdCreditsStat($cpdFilter: CPDCreditsFilter) {
    CpdCreditsStat(filter: $cpdFilter) {
      count
    }
  }
`;

export const GET_LOGIN_USERS_STAT = gql`
  query GetLoginUsersStat($loginStatFilter: LoginUsersFilter) {
    LoginUsersStat(filter: $loginStatFilter) {
      grouped_by_dates {
        date
        logins
        users {
          user_id
          session
          date
        }
      }
      total_count_logins
    }
  }
`;

export const GET_LAST_LOGIN_USERS_STAT = gql`
  query GetLastLoginUsersStat($loginStatFilter: LoginUsersFilter) {
    LastLoginUsersStat(filter: $loginStatFilter) {
      last_logins
    }
  }
`;

export const GET_LIST_BASE = gql`
  query GetListBaseVideoCategories {
    listBaseVideoCategories {
      id
      title
    }
  }
`;

export const GET_ANALYTICS = gql`
  query GetStatistics(
    $statisticFilter: statisticFilter
    $viewedHoursFilter: ViewedHoursFilter
    $viewedVideosFilter: ViewedVideosFilter
    $loginStatFilter: LoginUsersFilter
  ) {
    VideosWatchedByCathegoryStat(filter: $statisticFilter) {
      count
      users {
        user_id
        count
      }
      category {
        id
        parent_id
      }
    }

    ViewedHoursStat(filter: $viewedHoursFilter) {
      grouped_by_dates {
        date
        duration
        users {
          user_id
          duration
        }
      }
      total_view_duration
    }

    VideosWatchedCountStat(filter: $viewedVideosFilter) {
      grouped_by_dates {
        date
        count
        users {
          user_id
          count
        }
      }
      total_count_viewed_videos
    }

    LoginUsersStat(filter: $loginStatFilter) {
      grouped_by_dates {
        date
        logins
        users {
          user_id
          session
          date
        }
      }
      total_count_logins
    }

    listBaseVideoCategories {
      id
      title
    }
  }
`;

export const GET_USER_VIDEOS_PROGRESS_STAT = gql`
  query GetUserVideosProgressStat($filter: VideosProgressFilter) {
    UserVideosProgressStat(filter: $filter) {
      videos_progresses {
        time
        chapter
        last_position
        completed
        progress_percentage
        video {
          id
          title
          preview_url
          video_url
          duration
        }
      }
    }
  }
`;

export const GET_MANAGER_VIDEOS_PROGRESS_STAT = gql`
  query GetManagerVideosProgressStat($filter: VideosProgressFilter) {
    ManagerVideosProgressStat(filter: $filter) {
      videos_progresses
    }
  }
`;

export const GET_TABLES_ANALYTICS = gql`
  query GetTablesAnalytics(
    $pathwaysGroupedFilter: pathwaysGroupedFilter
    $videosGroupedFilter: videosGroupedFilter
  ) {
    PathwaysGroupedStat(filter: $pathwaysGroupedFilter) {
      pathway {
        id
        name
        description
        image_url
        duration
        slug
        cpd_credits
        formatted_duration
        count_videos
      }
      duration
      cpd_available
      users_started
      users_completed
      users_watched
      half_completed
    }

    VideosGroupedStat(filter: $videosGroupedFilter) {
      story_id
      view_duration
      title
      description
      presenter
      image
      users_started
      users_completed
      video_categories
      video_url
      video_duration
    }
  }
`;

export const GET_DETAILED_VIDEO_TABLE_ANALYTIC = gql`
  query GetDetailedVideoTableAnalytic($filter: UsersProgressOnVideoFilter) {
    getUsersProgressOnVideo(filter: $filter) {
      id
      complete
      last_position
      view_duration
      view_finish
      progress_percentage
      user {
        name
      }
    }
  }
`;

export const GET_ANALYTICS_FOR_WIDGET = gql`
  query GetShortStatistics(
    $statisticFilter: statisticFilter
    $viewedHoursFilter: ViewedHoursFilter
    $viewedVideosFilter: ViewedVideosFilter
  ) {
    VideosWatchedByCathegoryStat(filter: $statisticFilter) {
      count
      users {
        user_id
        count
      }
      category {
        id
        parent_id
      }
    }

    ViewedHoursStat(filter: $viewedHoursFilter) {
      grouped_by_dates {
        date
        duration
        users {
          user_id
          duration
        }
      }
      total_view_duration
    }

    VideosWatchedCountStat(filter: $viewedVideosFilter) {
      grouped_by_dates {
        date
        count
        users {
          user_id
          count
        }
      }
      total_count_viewed_videos
    }

    listBaseVideoCategories {
      id
      title
    }
  }
`;

export const GET_REPORT_BY_LEARNER = gql`
  query getReportByLearner($filter: GroupedByUsersFilter) {
    UsersGroupedStat(filter: $filter) {
      users_stat
    }
  }
`;

export const GET_PATHWAYS_STATS = gql`
  query GetPathwaysStats($filter: PathwayProgressFilter) {
    getUserPathwaysProgressStat(filter: $filter) {
      pathways_stat {
        completed
        total
      }
      cpd_credits_stat {
        completed
      }
      pathways_progresses_stat {
        pathway {
          id
          slug
          name
          image_url
          quizes {
            id
          }
        }
        pathway_watched_videos_count
        pathway_videos_count
        progress
        test_score
        status
      }
    }
  }
`;

export const GET_PATHWAYS_STATS_FOR_WIDGET = gql`
  query GetPathwaysStatsForWidget($filter: PathwayProgressFilter) {
    getUserPathwaysProgressStat(filter: $filter) {
      pathways_stat {
        completed
        total
      }
      cpd_credits_stat {
        completed
      }
    }
  }
`;

export const GET_DETAILED_PATHWAY_TABLE_ANALYTIC = gql`
  query GetDetailedPathwayTableAnalytic($filter: UsersProgressOnPathwaysFilter) {
    GetUsersProgressesByPathway(filter: $filter) {
      status
      progress
      user {
        id
        name
      }
    }
  }
`;

export const GET_VIEWED_HOURS_STAT_BY_STORY_IDS = gql`
  query GetViewedHoursStatByStoryIds($viewedHoursFilter: ViewedHoursFilter) {
    ViewedHoursStat(filter: $viewedHoursFilter) {
      grouped_by_dates {
        date
        duration
      }
      total_view_duration
    }
  }
`;

export const GET_VIDEOS_WATCHED_COUNT_STAT_BY_STORY_IDS = gql`
  query GetVideosWatchedCountStat($viewedVideosFilter: ViewedVideosFilter) {
    VideosWatchedCountStat(filter: $viewedVideosFilter) {
      grouped_by_dates {
        date
        count
      }
      total_count_viewed_videos
    }
  }
`;

export const GET_MANAGER_DETAILED_REPORT_BY_PATHWAYS = gql`
  query GetManagerDetailedReportByPathways($filter: DetailedReportFilter) {
    getManagerDetailedReportByPathways(filter: $filter) {
      items {
        pathway_id
        pathway_name
        pathway_duration
        progress
        test_passed
        test_score
        status
        learner {
          id
          name
          email
        }
      }
      count
    }
  }
`;

export const GET_MANAGER_DETAILED_REPORT_BY_VIDEOS = gql`
  query getManagerDetailedReportByVideos($filter: DetailedReportFilter) {
    getManagerDetailedReportByVideos(filter: $filter) {
      items {
        progress
        completed
        video {
          id
          title
          duration
          user {
            id
            name
          }
          categories {
            id
            title
          }
        }
        learner {
          id
          name
          email
        }
      }
      count
    }
  }
`;

export const GET_MANAGER_DETAILED_REPORT_BY_PATHWAYS_CSV_LINK = gql`
  query GetManagerDetailedReportByPathwaysCsvLink($filter: DetailedReportFilter) {
    getDetailedReportByPathwaysCsvLink(filter: $filter)
  }
`;

export const GET_MANAGER_DETAILED_REPORT_BY_VIDEOS_CSV_LINK = gql`
  query getManagerDetailedReportByVideosCsvLink($filter: DetailedReportFilter) {
    getDetailedReportByVideosCsvLink(filter: $filter)
  }
`;

export const GET_PATHWAYS_CERTIFICATES = gql`
  query GetPathwayCertificates($filter: CertificatesFilter) {
    getPathwayCertificates(filter: $filter) {
      pathway {
        id
        name
        image_url
        slug
        cpd_credits
        categories {
          id
          title
        }
      }
      hash
      date_passing
    }
  }
`;
